module.exports = __webpack_public_path__ + "img/section-01-anim-01-x2.6771770b.jpg";